import { Box } from '@mui/material'
import React from 'react'

import NewBadge from './NewBadge'

interface TripTypeTabLabelProps {
    label: string
    /** Badge text; when omitted, only the label is rendered. */
    badge?: string
    /**
     * Badge placement:
     *   - `desktop`: inline, next to the label (radio option).
     *   - `mobile`: pinned flush under the tab strip's top border (tab option).
     */
    variant: 'desktop' | 'mobile'
}

/** Trip-type option label with an optional "NEW"-style badge, placed per platform. */
const TripTypeTabLabel: React.FC<TripTypeTabLabelProps> = ({ label, badge, variant }) => {
    if (!badge) {
        return <>{label}</>
    }

    if (variant === 'mobile') {
        return (
            <Box component="span" sx={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
                {label}
                <NewBadge
                    label={badge}
                    sx={{
                        // Hangs flush under the tab strip's top border, centered over the label.
                        // Height comes from padding + text so "NEW" keeps even space inside the box.
                        position: 'absolute',
                        top: -16,
                        left: '50%',
                        transform: 'translateX(-50%)',
                        justifyContent: 'center',
                        width: '32px',
                        py: '3px',
                        fontSize: '8px',
                        borderRadius: '0 0 4px 4px'
                    }}
                />
            </Box>
        )
    }

    return (
        <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
            {label}
            <NewBadge label={badge} />
        </Box>
    )
}

export default TripTypeTabLabel
